import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/articles";

export default function Featured() {
  const top = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 6);

  return (
    <section className="w-full bg-background-100/60 border-y border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <SectionHeading
              eyebrow="热门爆料"
              title="正在发酵的瓜料，热度持续更新"
              desc="以下线索均已通过初审并进入发酵环节，状态标签会随着核实进度实时变化。"
            />
            <Link
              to="/square"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-primary-300 text-primary-600 text-sm font-medium whitespace-nowrap hover:bg-primary-50 transition-colors self-start md:self-auto"
            >
              查看全部爆料
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {top.map((article, index) => (
            <Reveal key={article.id} delay={(index % 3) * 80}>
              <ArticleCard article={article} index={index} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}